import WorkflowType from "../../../../enums/workflowType";
import BackIcon from "../../../../media/BackIcon";
import { AnalysisTitleBarProps } from "./AnalysisTitleBar.types";

const AnalysisTitleBar = (props: AnalysisTitleBarProps) => {

  const { workflow, onBack } = props

  if (workflow.status === "loading" || workflow.status === "idle") {
    return (
      <div className="analysis-header">
        <p>Loading...</p>
      </div>
    )
  }

  if (workflow.status === "error") {
    return (
      <div className="analysis-header">
        <p>Error</p>
      </div>
    ) 
  }

  return (
    <div className="analysis-header">
      <div className="analysis-back-button" onClick={onBack}>
        <BackIcon />
        <p>Back</p>
      </div>
      <h2 className="analysis-topbar-title">
        {workflow.data?.filename === "" ? workflow.data?.asset_id : workflow.data?.filename} {workflow.data?.workflow_type === WorkflowType.ANGULAR ? "" : "(Beta)"}
      </h2>
    </div>
  )
}

export default AnalysisTitleBar